export default __webpack_public_path__ + "static/media/dr.e98e8aae.jpg";